/**
 * Dubai Police 999 Emergency Assistant – Runtime Configuration
 *
 * Configuration is loaded from window._env_ (public/config.js) at startup
 * so the backend URL and other settings can be changed without rebuilding.
 *
 * Priority:
 *   1. window._env_  (config.js mounted at runtime – preferred for production)
 *   2. process.env   (build-time .env – fallback for local dev)
 */

interface RuntimeConfig {
  REACT_APP_BACKEND_URL: string;
  REACT_APP_NOMINATIM_API_URL: string;
}

declare global {
  interface Window {
    _env_?: Partial<RuntimeConfig>;
  }
}

function getConfig(): RuntimeConfig {
  if (window._env_ && window._env_.REACT_APP_BACKEND_URL) {
    console.log('[CONFIG] Loaded from config.js (runtime)');
    return {
      REACT_APP_BACKEND_URL:     window._env_.REACT_APP_BACKEND_URL,
      REACT_APP_NOMINATIM_API_URL: window._env_.REACT_APP_NOMINATIM_API_URL
        ?? 'https://nominatim.openstreetmap.org',
    };
  }

  console.log('[CONFIG] Loaded from process.env (build-time fallback)');
  return {
    REACT_APP_BACKEND_URL:
      process.env.REACT_APP_BACKEND_URL || 'https://dp-api.softecinternational.com',
    REACT_APP_NOMINATIM_API_URL:
      process.env.REACT_APP_NOMINATIM_API_URL || 'https://nominatim.openstreetmap.org',
  };
}

export const config = getConfig();

console.log('[CONFIG] Backend:', config.REACT_APP_BACKEND_URL || '(not set)');
